import React, { useEffect, useState } from "react"
import "../App.css"
import Form from "react-bootstrap/Form"

export default function Light(props: { id: string }) {
  const [name, setName] = useState("")
  const [brightness, setBrightness] = useState(0)
  const [hue, setHue] = useState(0)
  const [on, setOn] = useState(false)
  const [saturation, setSaturation] = useState(0)

  const hueHost = "192.168.0.189"
  const apiKey = "BcIxgrExcFf8m9rdaeclZ2Q20ctedDj841YoSabP"

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        `http://${hueHost}/api/${apiKey}/lights/${props.id}`,
      )
      const json = await response.json()
      console.log(
        `Fetched state for the light ${props.id}: ${JSON.stringify(json)}`,
      )
      setName(json.name ?? "")
      setBrightness(json.state.bri ?? 0)
      json.state.hue && setHue(json.state.hue)
      setOn(json.state.on)
      json.state.sat && setSaturation(json.state.sat)
    }

    fetchData().catch(console.error)
  }, [])

  const handleChangeBrightness = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const newBrightness = event.target.valueAsNumber
    updateLight(newBrightness, null, null, null)
  }

  const handleChangeHue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newHue = event.target.valueAsNumber
    updateLight(null, newHue, null, null)
  }

  const handleChangeOn = () => {
    updateLight(null, null, !on, null)
  }

  const handleChangeSaturation = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const newSaturation = event.target.valueAsNumber
    updateLight(null, null, null, newSaturation)
  }

  const updateLight = async (
    newBrightness: number | null,
    newHue: number | null,
    newOn: boolean | null,
    newSaturation: number | null,
  ) => {
    let newState = {}
    if (newBrightness != null) {
      newState = { bri: newBrightness }
    } else if (newHue != null) {
      newState = { hue: newHue }
    } else if (newOn != null) {
      newState = { on: newOn }
    } else if (newSaturation != null) {
      newState = { sat: newSaturation }
    }
    const request = JSON.stringify(newState)
    console.log(`Setting state to light ${props.id} to ${request}`)
    const apiRequest = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: request,
    }
    const response = await fetch(
      `http://${hueHost}/api/${apiKey}/lights/${props.id}/state`,
      apiRequest,
    )
    const json = await response.json()

    // debugger
    console.log(`Updated state for light ${props.id}: ${JSON.stringify(json)}`)
    if (newBrightness != null) {
      setBrightness(newBrightness)
    } else if (newHue != null) {
      setHue(newHue)
    } else if (newOn != null) {
      setOn(newOn)
    } else if (newSaturation != null) {
      setSaturation(newSaturation)
    }
  }

  return (
    <Form>
      <Form.Check
        checked={on}
        onChange={handleChangeOn}
        label={name}
        title={props.id}
      />
      <Form.Label>Brightness:</Form.Label>
      <Form.Range
        min="0"
        max="254"
        step="2"
        value={brightness}
        onChange={handleChangeBrightness}
        title={brightness.toString()}
      />
      <Form.Label>Hue:</Form.Label>
      <Form.Range
        min="0"
        max="65535"
        step="255"
        value={hue}
        onChange={handleChangeHue}
        title={hue.toString()}
      />
      <Form.Label>Saturation:</Form.Label>
      <Form.Range
        min="0"
        max="254"
        step="2"
        value={saturation}
        onChange={handleChangeSaturation}
        title={saturation.toString()}
      />
      <hr></hr>
    </Form>
  )
}
